import React from 'react';
import { Button, ButtonProps, styled, IconButton, ToggleButton } from '@mui/material';
import { createCartoonButtonStyles } from '../theme';

type CartoonButtonProps = ButtonProps & {
    color?: string;
}


export const CartoonIconButton = styled(IconButton)<CartoonButtonProps>(({ color, theme }) => {
    return {
        ...createCartoonButtonStyles(color || '#FF5722', theme),
        padding: '0px',
        width: '45px',
        height: '45px',
        borderRadius: '40%',

    };
})

export const CartoonToggleButton = styled(ToggleButton)(
    ({ theme }) => {
        return {
            ...createCartoonButtonStyles('rgba(0, 0, 0, 0.1)', theme),
            "&.Mui-selected": {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                },
            },
        }
    }


);


const StyledButton = styled(Button)<CartoonButtonProps>(({ color, theme }) =>
    createCartoonButtonStyles(color || '#FF5722', theme) // Default color is #FF5722
);

const CartoonButton: React.FC<CartoonButtonProps> = ({ color, children, ...props }) => {
    return (
        <StyledButton color={color} {...props}>
            {children}
        </StyledButton>
    );
};

export default CartoonButton;